// 單曲頁的播放器共用同一個 <audio>（2026-10-04，docs/MUSIC.md §播放器）。
// 為什麼不放在元件模板裡：換歌是站內換頁，元件會整個重掛；iOS Safari 只認「被手勢播過的那個元素」，
// 同一個元素換 src 接著播才放得出聲音。播完倒數跳下一首、Media Session 的「下一首」都靠這個。
// 只在瀏覽器裡建立；預渲染與測試環境不會碰到。

let audio = null
let continueSlug = ''

export function sharedAudio() {
  if (typeof window === 'undefined' || typeof Audio === 'undefined') return null
  if (!audio) {
    audio = new Audio()
    audio.preload = 'metadata'
  }
  return audio
}

// 播完倒數跳到下一首（或按了 Media Session 的下一首）：記下要接著播的那首，下一頁掛上時不看「進頁自動播放」開關
export const markContinue = slug => { continueSlug = slug || '' }
export const takeContinue = slug => {
  const hit = !!slug && continueSlug === slug
  continueSlug = ''
  return hit
}

const KEY = 'cheyu_music_autoplay'
export function autoplayPreference() {
  try { return localStorage.getItem(KEY) !== '0' } catch { return true }
}
export function setAutoplayPreference(on) {
  try { on ? localStorage.removeItem(KEY) : localStorage.setItem(KEY, '0') } catch { /* 私密瀏覽等：只是這次不記 */ }
}

// 進頁要不要自己開始播：接著播一定播；否則看開關、省流量模式、這份文件有沒有使用者手勢（站內點進來才有）
export function shouldAutoplay({ continued, preference, nav = typeof navigator === 'undefined' ? undefined : navigator }) {
  if (continued) return true
  if (!preference || !nav) return false
  if (nav.webdriver === true) return false   // 預渲染的無頭瀏覽器：不自己開播，快照才不會一次「Playing」一次「Tap to listen」
  if (nav.connection?.saveData) return false
  const activation = nav.userActivation
  return activation ? !!activation.hasBeenActive : true
}
